<div class="container">
    <h1>Authentication Failed</h1>
    <p>An error occurred during the login process or the authentication was canceled by the user.</p>
    <p>Please click the button below to try again.</p>

    <fsn-button variant="primary" (click)="retry()">Retry</fsn-button>
</div>
